// Import from NPM
// -------------------------------------
import _ from "lodash";

// Import from Config
// -------------------------------------
import { Div, Image } from "@components/Generics.react";
import { settings } from "@config/settings/app.settings";
// Import Components
// -------------------------------------

export default function SocialLogin(props) {
    // ========================= Render Function =================================
    return (
        <Div padTop flex column gapped clickable>
            {settings.socialauthlogin.length > 0 &&
                _.map(settings.socialauthlogin, (btn, idx) => {
                    return (
                        <Image
                            key={`social-auth-${idx}`}
                            fluid
                            src={btn.image}
                            onClick={() => {
                                const redirectUrl = btn.url || null
                                if (redirectUrl) {
                                    if (btn.url.startsWith('http')) {
                                        window.open(redirectUrl, '_blank');
                                    } else {
                                        window.location.href = redirectUrl;
                                    }
                                }
                            }}
                        />
                    );
                })}
        </Div>
    );
}
